import { Flex } from '@mantine/core';
import type { RefObject } from 'react';
import { useProcessAnalysisStore } from '../../../../store/process-analysis-store/process-analysis-store';
import { setSelectedBoards } from '../../../../store/process-analysis-store/process-analysis-store.actions';
import { MainSectionControls } from '../../components/main-section-controls/main-section-controls';
import { useCSVExportHandler } from '../../hooks/use-csv-export';
import { ResetSelectionButton } from '../../components/reset-selection-button/reset-selection-button';
import { BoardComparisonSelector } from './board-comparison-selector';

export const MainSectionHeader = ({ chartRef }: { chartRef: RefObject<HTMLDivElement | null> }) => {
  const selectedBoards = useProcessAnalysisStore((state) => state.selectedBoards);
  const csvExportHandler = useCSVExportHandler();

  const showReset = selectedBoards.length > 0;

  return (
    <Flex justify="space-between" align="center">
      <Flex align="center" gap={8}>
        <BoardComparisonSelector />
        {showReset && <ResetSelectionButton onClick={() => setSelectedBoards([])} />}
      </Flex>
      <MainSectionControls onExportCSV={csvExportHandler} chartRef={chartRef} />
    </Flex>
  );
};
